/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import DMNModdle from 'dmn-moddle';

import { getDecisions } from 'utils/web-modeler-diagram-parser/decisions-util';

const moddle = new DMNModdle();

export const createDMNDIEntitiesIfMissingFromXML = async (xml) => {
  try {
    const { rootElement: definitions } = await moddle.fromXML(xml);

    if (definitions.dmnDI) {
      return xml;
    }

    definitions.dmnDI = moddle.create('dmndi:DMNDI', {
      diagrams: [moddle.create('dmndi:DMNDiagram', {})]
    });

    const dmnDiagram = definitions.dmnDI.diagrams[0];
    const decisions = await getDecisions(definitions);
    const diagramElements = [];

    // Create DMNShape elements for each decision element
    decisions.forEach((decision, index) => {
      const dmnShape = moddle.create('dmndi:DMNShape', {
        id: `DMNShape_${index + 1}`,
        dmnElementRef: decision,
        bounds: moddle.create('dc:Bounds', {
          x: 150 + index * 30,
          y: 150 + index * 30,
          width: 180,
          height: 80
        })
      });

      diagramElements.push(dmnShape);
    });

    dmnDiagram.diagramElements = diagramElements;

    const { xml: updatedXML } = await moddle.toXML(definitions, { format: true });
    return updatedXML;
  } catch (error) {
    console.error('Error creating DMNDI nodes:', error);
    throw error;
  }
};
